import * as t from 'io-ts'

export const PublishCodec = t.type({
    executionArn: t.string,
    startDate: t.string,
})
export type Publish = t.TypeOf<typeof PublishCodec>
